<template>
  <div class="resource-preview-page">
    <PDFPreview
      v-if="pdfUrl && !blocked"
      :pdf-url="pdfUrl"
      :title="fileName"
    />
    <div v-else-if="blocked" class="resource-preview-page__empty">
      <p>{{ blockedMessage }}</p>
      <button type="button" class="resource-preview-page__back" @click="closePage">关闭</button>
    </div>
    <div v-else class="resource-preview-page__empty">
      <p>无效的文件地址</p>
      <button type="button" class="resource-preview-page__back" @click="closePage">关闭</button>
    </div>
  </div>
</template>

<script>
import PDFPreview from './components/PDFPreview.vue'
import {
  getArchivePdfPreviewBlockReason,
  getArchivePdfPreviewBlockMessage
} from '@/utils/resourceAccess'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ResourcePreview',
  components: {
    PDFPreview
  },
  data() {
    return {
      blocked: false,
      blockedMessage: ''
    }
  },
  computed: {
    ...mapState('user', ['userInfo']),
    ...mapGetters(['isLoggedIn']),
    pdfUrl() {
      return (this.$route.query.url || '').trim()
    },
    fileName() {
      return (this.$route.query.name || 'PDF 预览').trim()
    },
    resourceInfo() {
      return {
        resourceType: this.$route.query.resourceType || '',
        resourceTypeLabel: this.$route.query.resourceTypeLabel || ''
      }
    }
  },
  mounted() {
    const reason = getArchivePdfPreviewBlockReason(
      this.userInfo,
      this.isLoggedIn,
      this.resourceInfo
    )
    this.blocked = !!reason
    this.blockedMessage = getArchivePdfPreviewBlockMessage(reason)
  },
  methods: {
    closePage() {
      window.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-preview-page {
  height: 100vh;
  overflow: hidden;
  background: $color-cream;

  &__empty {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: $spacing-base;
    color: $color-text-light;
  }

  &__back {
    padding: 8px 20px;
    border: none;
    border-radius: 4px;
    background: $color-green-dark;
    color: $color-white;
    font-size: rem(14);
    cursor: pointer;
  }
}
</style>
